/**
 * steps theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/steps.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { stepsAnatomy } from '@chakra-ui/react/anatomy';
export const steps = defineSlotRecipe({
    slots: stepsAnatomy.keys(),
    base: {},
    variants: {
        variant: {
            stepper: {
                list: {
                    '--steps-thickness': '1px',
                },
                trigger: {
                    gap: '4px',
                    _incomplete: {
                        color: 'state.disabled',
                    },
                },
                indicator: {
                    cursor: 'pointer',
                    textAlign: 'center',
                    padding: '0px 7px',
                    width: '16px',
                    height: '16px',
                    textStyle: 'overline',
                    color: 'black',
                    _current: {
                        color: 'background.offWhite',
                        bg: 'black',
                    },
                    _incomplete: {
                        bg: 'state.disabled',
                        color: 'background.offWhite',
                    },
                    _complete: {
                        bg: 'black',
                        color: 'background.offWhite',
                    },
                },
                title: {
                    textStyle: 'overline',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    lineClamp: 1,
                    wordBreak: 'break-all',
                    color: 'currentcolor',
                },
                separator: {
                    bg: 'state.disabled',
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {},
});
